import { render, staticRenderFns } from "./vip_popup.vue?vue&type=template&id=cda3fdfe&scoped=true"
import script from "./vip_popup.vue?vue&type=script&lang=js"
export * from "./vip_popup.vue?vue&type=script&lang=js"
import style0 from "./vip_popup.vue?vue&type=style&index=0&id=cda3fdfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda3fdfe",
  null
  
)

export default component.exports